import React from 'react';
import { useDispatch } from 'react-redux';
import useAppSelector from '../app/redux/useAppSelector';
import ModeToggle from '../components/ModeToggle';
import Tooltip from '../components/Tooltip';
import { BEACON_POST_MODE_TOGGLE } from '../constants/onboarding';
import EditorActions from '../editor/EditorActions';
import TutorialBeacon from '../onboarding/tutorial/TutorialBeacon';

const PostModeToggle = () => {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const editable = useAppSelector((state) => state.editor.editable);
  const isLocked = useAppSelector(
    (state) => state.session.organization.isLocked,
  );
  const readOnly = useAppSelector((state) => state.editor.readOnly);

  const dispatch = useDispatch();

  const toggleMode = () => dispatch(EditorActions.readOnly(!readOnly));

  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const disabled = !editable || isLocked;

  const inner = (
    <TutorialBeacon id={BEACON_POST_MODE_TOGGLE} placement="bottom-start">
      {(props) => (
        <div {...props}>
          <ModeToggle
            left={readOnly ? 'Edit' : 'Editing'}
            right={readOnly ? 'Reading' : 'Read'}
            leftActive={!readOnly}
            disabled={!!disabled}
            onToggle={toggleMode}
          />
        </div>
      )}
    </TutorialBeacon>
  );

  return disabled ? (
    <Tooltip
      enabledForSmallSize
      trigger="hover"
      placement="bottom"
      tooltip="This post is read-only and cannot be edited."
    >
      {inner}
    </Tooltip>
  ) : (
    inner
  );
};

export default PostModeToggle;
